module.exports = __webpack_public_path__ + "img/bird-3-1.4b2bee5f.jpg";